import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aprobacion-evaluacion-especialista',
  templateUrl: './aprobacion-evaluacion-especialista.component.html',
  styleUrls: ['./aprobacion-evaluacion-especialista.component.scss']
})
export class AprobacionEvaluacionEspecialistaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
